export default __webpack_public_path__ + "static/media/services-screen.370a7159.jpg";